export default function (state, getters, rootState, rootGetters) {
    let data = {};
    let rules = rootGetters['clients/item/rules/list'];
    if (!rules) return null;
    if (req(rules, 'Name') && !state.Name) return null;
    data.Name = state.Name;
    if (req(rules, 'FirstName') && !state.FirstName) return null;
    data.FirstName = state.FirstName;
    if (req(rules, 'MiddleName') && !state.MiddleName) return null;
    data.MiddleName = state.MiddleName;
    if (req(rules, 'NameLat') && !state.NameLat) return null;
    data.NameLat = state.NameLat;
    if (req(rules, 'FirstNameLat') && !state.FirstNameLat) return null;
    data.FirstNameLat = state.FirstNameLat;
    if (req(rules, 'MiddleNameLat') && !state.MiddleNameLat) return null;
    data.MiddleNameLat = state.MiddleNameLat;
    if (req(rules, 'Code') && !state.Code) return null;
    data.Code = state.Code;
    if (req(rules, 'CitizenId') && !state.CitizenId) return null;
    data.CitizenId = state.CitizenId;
    if (req(rules, 'Constant') && !state.Constant) return null;
    data.Constant = state.Constant;
    if (req(rules, 'Birthday') && !state.Birthday) return null;
    data.Birthday = {Serialized: state.Birthday};
    if (req(rules, 'Gender') && !(state.Gender >= 0)) return null;
    data.Gender = state.Gender;
    if (req(rules, 'AgeCategory') && !(state.AgeCategory >= 0)) return null;
    data.AgeCategory = state.AgeCategory;
    if (req(rules, 'Comment') && !state.Comment) return null;
    data.Comment = state.Comment;
    return data;
}

function req(rules, field) {
    return (rules[field] && rules[field][0] && rules[field][0].required)
}